import { DashboardFontIcon, DashboardTextElement } from '../style';
import { wrapComponentWithLink } from '../../../router';
import DashboardLink from './DashboardLink';

export const DashboardText = ({ iconName, textKey }: $TSFixMe) => (
    <>
        <DashboardFontIcon value={iconName} />
        <DashboardTextElement textKey={textKey} />
    </>
);

const DashboardTextLink = wrapComponentWithLink({
    LinkElement: DashboardLink,
    WrappedComponent: DashboardText,
});

export default DashboardTextLink;
